import { IRawComponent } from 'projects/common/src/app/interfaces/remote-models';

export class UpdateChangeView {
  static readonly type = '[Dashboard] update change view';
  constructor(public payload: boolean) {}
}
export class UpdateShowTable {
  static readonly type = '[Dashboard] update show table to false or true';
  constructor(public payload: IRawComponent, public switcher: boolean) {}
}

export class UpdateChangeViewButtonIcon {
  static readonly type = '[Dashboard] update change view button icon';
  constructor(public payload: string) {}
}
export class UpdateTitleDashboard {
  static readonly type = '[Dashboard] update title';
  constructor(public payload: string) {}
}
export class UpdateIsTitleDashboard {
  static readonly type = '[Dashboard] update is title to false or true';
  constructor(public payload: boolean) {}
}
